import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScienceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"science"}/>
}
